import axios from 'axios';
import { toast } from 'react-hot-toast';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

if (!apiBaseUrl) {
  throw new Error("REACT_APP_API_BASE_URL no está configurada");
}

const instance = axios.create({
    baseURL: apiBaseUrl,
    headers: {
        "Content-Type": "application/json",
    },
});

instance.interceptors.request.use((config) => {
    const authHeader = sessionStorage.getItem("authHeader");
    if (authHeader) {
        config.headers["Authorization"] = authHeader;
    }
    return config;
});

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        const requestUrl = error.config?.url ?? "";
        const status = error.response?.status;

        // El login debe gestionar su propio 401 para mostrar
        // "credenciales incorrectas" en la pantalla de acceso.
        const isLoginRequest = requestUrl.includes("/login");

        if (status === 401 && !isLoginRequest) {
            sessionStorage.removeItem("authHeader");
            localStorage.removeItem("isAuthenticated");
            toast.error("Tu sesión ha expirado. Vuelve a iniciar sesión.");

            if (window.location.pathname !== "/login") {
                window.location.replace("/login");
            }
        }

        if (status === 403) {
            toast.error("No tienes permisos para realizar esta acción.");
        }

        if (!error.response) {
            toast.error("No se ha podido conectar con el servidor.");
        }

        return Promise.reject(error);
    }
);

export default instance;
